import React from 'react'

import Styles from './styles'
import { FormattedMessage } from 'react-intl'
import LocationIcon from 'assets/img/svg/location-icon.svg'
import ShopIcon from 'assets/img/svg/shop-icon.svg'
import ClockIcon from 'assets/img/svg/clock-icon.svg'
import ClosedIcon from 'assets/img/svg/closed-icon.svg'

const VARIANTS = {
  ALL: {
    color: '#8176f1',
  },
  OPEN: {
    color: '#38A169',
  },
  CLOSED_PERMANENTLY: {
    color: '#E53E3E',
  },
  CLOSED_TEMPORARY: {
    color: '#D69E2E',
  },
}
const LocationCountCardContext = React.createContext()

export default function StatusCard({ variant = 'ALL', children }) {
  const values = VARIANTS[variant] || VARIANTS.ALL

  return (
    <LocationCountCardContext.Provider value={values}>
      <Container>{children}</Container>
    </LocationCountCardContext.Provider>
  )
}

const useLocationCountCard = () => {
  const context = React.useContext(LocationCountCardContext)
  if (!context) {
    throw new Error(
      'LocationCountCard compound components cannot be rendered outside the LocationCountCard component'
    )
  }
  return context
}

function Container({ children }) {
  const { color } = useLocationCountCard()
  return (
    <Styles.CardContainer cardColor={color}>{children}</Styles.CardContainer>
  )
}

function Icon({ src, alt }) {
  const { color } = useLocationCountCard()
  return (
    <Styles.CardIcon cardColor={color}>
      <img src={src} alt={alt} />
    </Styles.CardIcon>
  )
}

StatusCard.Content = Styles.CardContent
StatusCard.Icon = Icon
StatusCard.Title = Styles.CardTitle
StatusCard.Description = Styles.CardDescription

StatusCard.ALL = ({ count }) => {
  return (
    <StatusCard>
      <StatusCard.Icon src={LocationIcon} />
      <StatusCard.Content>
        <StatusCard.Title>{count}</StatusCard.Title>
        <StatusCard.Description>
          <FormattedMessage id="status_card.ALL" />
        </StatusCard.Description>
      </StatusCard.Content>
    </StatusCard>
  )
}

StatusCard.OPEN = ({ count }) => {
  return (
    <StatusCard variant="OPEN">
      <StatusCard.Icon src={ShopIcon} />
      <StatusCard.Content>
        <StatusCard.Title>{count}</StatusCard.Title>
        <StatusCard.Description>
          <FormattedMessage id="status_card.OPEN" />
        </StatusCard.Description>
      </StatusCard.Content>
    </StatusCard>
  )
}

StatusCard.CLOSED_PERMANENTLY = ({ count }) => {
  return (
    <StatusCard variant="CLOSED_PERMANENTLY">
      <StatusCard.Icon src={ClosedIcon} />
      <StatusCard.Content>
        <StatusCard.Title>{count}</StatusCard.Title>
        <StatusCard.Description>
          <FormattedMessage id="status_card.CLOSED_PERMANENTLY" />
        </StatusCard.Description>
      </StatusCard.Content>
    </StatusCard>
  )
}

StatusCard.CLOSED_TEMPORARY = ({ count }) => {
  return (
    <StatusCard variant="CLOSED_TEMPORARY">
      <StatusCard.Icon src={ClockIcon} />
      <StatusCard.Content>
        <StatusCard.Title>{count}</StatusCard.Title>
        <StatusCard.Description>
          <FormattedMessage id="status_card.CLOSED_TEMPORARY" />
        </StatusCard.Description>
      </StatusCard.Content>
    </StatusCard>
  )
}
